import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { WorkSearch } from '@App/stores/search/models/work-search'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'
import { v4 as uuidv4 } from 'uuid'
import getWorkAutoCompleteSuggestions from '@App/helpers/search/get-work-autocomplete-suggestions'
import getWriterNameAutoCompleteSuggestions from '@App/helpers/search/get-writer-name-auto-complete-suggestions'
import getPublisherNameAutoCompleteSuggestions from '@App/helpers/search/get-publisher-name-auto-complete-suggestions'

export const SEARCH_OVERCLAIM_OPTIONS: Array<SelectOptionHide<WorkSearch>> = [
    {
        id: uuidv4(),
        value: 'combinedTitles',
        label: 'Work Title',
        isPrimary: true,
        autoCompleteFetcher: getWorkAutoCompleteSuggestions,
        exactMatchOnly: true,
    },
    {
        id: uuidv4(),
        value: 'writerFullNames',
        label: 'Writer Name',
        autoCompleteFetcher: getWriterNameAutoCompleteSuggestions,
        exactMatchOnly: true,
    },
    { id: uuidv4(), value: 'iswc', label: 'ISWC', isPrimary: true },
    { id: uuidv4(), value: 'hfaSongCode', label: 'MLC Song Code', isPrimary: true },
    { id: uuidv4(), value: 'writerNameNumbers', label: 'Writer IPI' },
    {
        id: uuidv4(),
        value: 'originalPubNames',
        label: 'Publisher Name',
        autoCompleteFetcher: getPublisherNameAutoCompleteSuggestions,
        exactMatchOnly: true,
    },
    { id: uuidv4(), value: 'originalPubIpiNameNumbers', label: 'Publisher IPI' },
    { id: uuidv4(), value: 'bothPublisherNumbers', label: 'MLC Publisher Number' },
]

class OverclaimSearchCriteriaStore extends SearchCriteriaStore<WorkSearch> {
    constructor(
        criteria: Array<SearchCriterion<WorkSearch>>,
        options: typeof SEARCH_OVERCLAIM_OPTIONS,
        optionType: SearchOptionType,
        requiredCriteria: RequiredCriteria,
        maxCriteria: number
    ) {
        super(criteria, options, optionType, requiredCriteria, maxCriteria)
    }
}

export default OverclaimSearchCriteriaStore
